export default __webpack_public_path__ + "2c958ec2e3a294faa5986c3fee22a355.png";